export const QUICK_VIEW_ROOT_ID = 'quick-view-root'
